import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormSyncErrors, getFormAsyncErrors, getFormSubmitErrors } from 'redux-form';
import { Form, Alert, Button, Spinner, Col } from 'react-bootstrap';
import { renderField } from '../../common/FormsControls.jsx';
import { dateFormat, string } from '../../../../_utils/validators';

import ProfileErrors from './ProfileErrors.jsx';

import normalizeDate from './normalizeDate';
import { FORM_FIELDS } from './formFields';


const ProfileFormFirst = (props) => {
  let errors = {...props.errors, ...props.aErrors, ...props.sErrors}

  let elementsRef = [];
  const excludeFields = ['sex'];
  for (let key of Object.keys(FORM_FIELDS)) {
    if (!excludeFields.includes(key)){
      elementsRef[key + '_Ref'] = useRef(null);
    }
  }

  const handleErrorClick = (e, fieldName) => {
    e.preventDefault();
    elementsRef[fieldName + '_Ref'].current.focus();
  }

  return(
    <Form onSubmit={ props.handleSubmit } className={ '' + (props.anyTouched ? ' was-validate' : '') }>

      <Field label={ gettext('Имя') }
             component={ renderField }
             validate={ [string] }
             onBlur={ props.setLocalStorage }
             inputRef={ elementsRef['first_name_Ref'] }
             name='first_name'/>

      <Field label={ gettext('Фамилия') }
             component={ renderField }
             validate={ [string] }
             onBlur={ props.setLocalStorage }
             inputRef={ elementsRef['last_name_Ref'] }
             name='last_name'/>

      <Form.Row>
        <Col sm={ 12 } md={ 6 }>
          <Field label={ gettext('Дата рождения') }
                 placeholder={ '__.__.____' }
                 helptext={ gettext('Не обязательно. Но мы будем присылать вам персональные подарки!') }
                 disabled={ props.initialValues.birthday }
                 component={ renderField }
                 validate={ [dateFormat] }
                 normalize={ normalizeDate }
                 onBlur={ props.setLocalStorage }
                 inputRef={ elementsRef['birthday_Ref'] }
                 name='birthday'/>
        </Col>
        <Col sm={ 12 } md={ 6 }>
          <Field label={ gettext('Пол') }
                 component={ renderField }
                 onBlur={ props.setLocalStorage }
                 element='select'
                 name='sex'>
              <option value={''}>{ gettext('Не указан') }</option>
              <option value={'male'}>{ gettext('Мужской') }</option>
              <option value={'female'}>{ gettext('Женский') }</option>
          </Field>
        </Col>
      </Form.Row>

      { props.invalid &&
        <Alert variant='danger' className='mt-3'>
          { gettext('Проверьте правильность заполнения формы.') }
          <ProfileErrors errors={ errors } onErrorClick={ handleErrorClick }/>
        </Alert>
      }

      <div className='text-lg-right mt-3'>
        <Button variant="orange" type="submit" disabled={ props.submitting || props.invalid }
                className='mt-2 mt-md-0'>
          { props.submitting
            ? <>
                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" className='mr-1'/>
                { gettext('Сохраняется') + '...' }
              </>
            : gettext('Сохранить') }
        </Button>
      </div>
    </Form>);
}

ProfileFormFirst.PropTypes = {
  initialValues: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    birthday: PropTypes.string,
    sex: PropTypes.string,
  }),
  handleSubmit: PropTypes.func.isRequired,
  anyTouched: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  aErrors: PropTypes.object,
  sErrors: PropTypes.object,
  fields: PropTypes.object,
}

let mapStateToProps = (state) => {
  return {
    errors: getFormSyncErrors('profileFormFirst')(state),
    aErrors: getFormAsyncErrors('profileFormFirst')(state),
    sErrors: getFormSubmitErrors('profileFormFirst')(state),
  }
};

export default compose(
  connect(mapStateToProps, {}),
  reduxForm({
    form:'profileFormFirst',
    enableReinitialize: true,
  }),
)(ProfileFormFirst);

